<template>
  <!-- Contextual "?" trigger; opens HelpModal for the given helpId. -->
  <button
    type="button"
    class="help-icon-btn"
    :title="title"
    :aria-label="title"
    @click.stop="open"
  >
    ?
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import { useHelpContentStore } from "@/stores/helpContentStore";

export default {
  name: "HelpIcon",
  props: {
    helpId: { type: String, required: true },
    accountType: { type: String, default: "" },
    title: { type: String, default: "Help for this feature" },
  },
  computed: {
    ...mapGetters("login", { allData: "getAllData" }),
    accountnumber() {
      return this.allData?.manager?.externid2 || this.allData?.patient?.externId2 || "";
    },
  },
  methods: {
    open() {
      useHelpContentStore().openHelp(this.helpId, {
        accountnumber: this.accountnumber,
        accountType: this.accountType,
        allData: this.allData,
      });
    },
  },
};
</script>

<style scoped>
.help-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-left: 0.35rem;
  border-radius: 50%;
  border: 2px solid #4b9ca5;
  background: #fff;
  color: #24555b;
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
}

.help-icon-btn:hover {
  background: #fff;
  border-color: #24555b;
  color: #24555b;
}
</style>
